import { useGetUserNameWithFallback } from '@pba/react-utils';
import { type ProgramEventInvitee, isRegisteredProgramInvitee } from 'models';
import { AvatarWrapper, Icon } from 'ui';
import { useUser } from 'features/auth';
import { IconDirectMessageButton } from 'features/chat';

type P = {
  user: ProgramEventInvitee;
};

const EventInviteeAvatar = ({ user }: P) => {
  const { railsUserData: viewer } = useUser();
  const getUserNameWithFallback = useGetUserNameWithFallback();

  return (
    <AvatarWrapper
      avatar={{
        badge: {
          count: (
            <Icon
              backgroundColor="white"
              color="success"
              icon="check-circle-fill"
              shape="circle"
              size="extra-extra-small"
            />
          ),
        },
        src: isRegisteredProgramInvitee(user) ? user.profilePhoto : undefined,
      }}
      extra={isRegisteredProgramInvitee(user) ? <IconDirectMessageButton legacyUserId={user.id} /> : null}
      user={{
        isViewer: isRegisteredProgramInvitee(user) ? user.id === viewer.id : false,
        name: isRegisteredProgramInvitee(user) ? getUserNameWithFallback(user) : user.email,
      }}
    />
  );
};

export default EventInviteeAvatar;
